<template>
  <div>
    <reservation-form
      @save="editReservation"
      @cancel="cancelEditReservation"
      @delete="deleteReservation"
      v-loading.fullscreen.lock="fullscreenLoading"
      :reservation="reservation"
      :line="line"
      type="edit" />

    <!-- Cancel Create Dialog -->
    <el-dialog :visible.sync="control.showCancelCreateDialog" :closeOnClickModal="false" :showClose="false" style="margin-top: 19vh;" width="30%">
      <div style="display: flex; justify-content: row; align-items: center; margin-top: 30px;">
        <img width="38" height="38" src="https://storage.healthathome.in.th/87d115c7-a7c9-48f0-a2c7-23728a96f917.svg" />
        <div class="dialog-header-18" style="margin-left: 17px;">คุณต้องการยกเลิกการอัพเดตข้อมูล ?</div>
      </div>
      <span class="dialog-footer" slot="footer">
        <el-button class="cancel-button" @click="handleCancel(false, reservationId)">ไม่</el-button>
        <el-button type="primary" @click="handleCancel(true, reservationId)" class="edit">ยกเลิก</el-button>
      </span>
    </el-dialog>

    <!-- Delete Reservation Dialog -->
    <el-dialog :visible.sync="control.showDeleteReservationDialog" :showClose="false" :closeOnClickModal="false" style="margin-top: 19vh;" width="30%">
      <div style="display: flex; justify-content: row; align-items: center; margin-top: 30px;">
        <img width="38" height="38" src="https://storage.healthathome.in.th/87d115c7-a7c9-48f0-a2c7-23728a96f917.svg" style="align-self: flex-start;" />
        <div v-if="!reservation.recurring" class="dialog-header-18" style="margin-left: 17px;">คุณต้องการลบการจองนี้่ ?</div>
        <div v-else class="dialog-header-18" style="margin-left: 17px;">หากคุณยืนยันที่จะลบการจองนี้<br>ระบบตัดบัตรอัตโนมัติจะถูกยกเลิก</div>
      </div>
      <span class="dialog-footer" slot="footer">
        <el-button class="cancel-button" @click="handleDelete(false, selectedReservation)">ยกเลิก</el-button>
        <el-button type="primary" @click="handleDelete(true, selectedReservation)" class="edit">ยืนยัน</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import ReservationForm from '@/components/reservation/ReservationForm'
import { GenericAPIHandler } from '../shared/GenericAPIHandler'
import moment from 'moment'
import { ReservationModel } from '../../model/ReservationModel'
import PatientModel from '@/model/PatientModel'

export default {
  name: 'ReservationEdit',
  mixins: [GenericAPIHandler],
  data () {
    return {
      fullscreenLoading: false,
      reservation: {},
      customer: {},
      line: '',
      control: {
        showCancelCreateDialog: false,
        showDeleteReservationDialog: false,
      },
      selectedReservation: {},
    }
  },
  props: {
    reservationId: {
      type: Number,
      required: true,
    },
  },
  mounted () {
    this.getReservation()
  },
  components: {
    ReservationForm,
  },
  methods: {
    async getReservation () {
      try {
        this.fullscreenLoading = true
        const raw = await this.$api.Reservation.prepareupdate(this.reservationId)
        this.reservation = ReservationModel.fromJSON(raw)
        await this.getLineID()
      } catch (error) {
        this.showErrorDialog(error)
      } finally {
        this.fullscreenLoading = false
      }
    },
    cancelEditReservation () {
      this.control.showCancelCreateDialog = true
    },
    handleCancel (status, reservationId) {
      if (status) {
        this.$router.push({ name: 'PatientDetail', params: { reservationId }, query: { tab: 'workcalendarTab' } })
      }
      this.control.showCancelCreateDialog = false
    },
    deleteReservation (reservation) {
      this.control.showDeleteReservationDialog = true
      this.selectedReservation = reservation
    },
    async handleDelete (status, reservation) {
      if (status) {
        try {
          await this.$api.Reservation.remove(reservation.id)
          this.$alert('เย่ ลบการจองสำเร็จ', 'บันทึกข้อมูล', {
            showConfirmButton: false,
            closeOnHashChange: true,
            callback: () => {
              this.$router.push({ name: 'PatientDetail', params: { id: reservation.patientId }, query: { tab: 'workcalendarTab' } })
            },
            type: 'success',
          })
          let interval = setTimeout(() => {
            location.hash = 'confirm'
            clearTimeout(interval)
            this.$router.push({ name: 'PatientDetail', params: { id: reservation.patientId }, query: { tab: 'workcalendarTab' } })
          }, 1000)
        } catch (error) {
          this.showErrorDialog(error)
        }
      }
      this.control.showDeleteReservationDialog = false
    },
    async editReservation (form) {
      const value = JSON.parse(JSON.stringify(form))
      value.reservation.dates = value.reservation.dates.sort(function (a, b) {
        return moment(a).isAfter(b)
      })
      try {
        this.fullscreenLoading = true
        await this.$api.Reservation.update(value.reservation)
        this.showSuccessDialog({ name: 'PatientDetail', params: { id: value.reservation.patientId }, query: { tab: 'workcalendarTab' } })
      } catch (error) {
        this.showErrorDialog(error)
      } finally {
        this.fullscreenLoading = false
      }
    },
    async getLineID () {
      try {
        const raw = await this.$api.Patient.get(this.reservation.patientId)
        this.customer = PatientModel.fromJSON(raw).transformToDisplayable()
        this.line = this.customer.lineId
      } catch (error) {
        this.showErrorDialog(error)
      }
    },
  },
}
</script>
